// API-Basis-URL für lokalen XAMPP-Server
//const API_BASE_URL = 'http://localhost/api.php';
const API_BASE_URL = 'https://bencrm.de/api.php';

// Hello World Funktion für Root-Endpoint
export const getHelloWorld = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getHelloWorld`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Login-Anfrage mit E-Mail statt Benutzername
export const login = async (email, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    // Text-Response abrufen und als JSON parsen
    const responseText = await response.text();
    console.log('Login Response:', responseText);

    let data;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      console.error("JSON-Parsing-Fehler:", parseError);
      return { success: false, error: "Server-Antwort konnte nicht verarbeitet werden" };
    }

    return data;
  } catch (err) {
    console.error("Netzwerkfehler beim Login:", err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const register = async (email, fullName, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, fullName, password }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Leads abrufen
export const getLeads = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getLeads&userId=${userId}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getCustomerDetails = async (userId, customerId, agenturID, aTeamID) => {
  try {
    console.log("aGenturID : ", agenturID)
    console.log("aTeamID : ", aTeamID)

    // Konsistent mit anderen API-Aufrufen - direkte URL-Parameter
    let url = `${API_BASE_URL}?action=getCustomerDetails&userId=${userId}&customerId=${customerId}`;

    // Nur agenturId und aTeamId hinzufügen, wenn sie nicht leer sind
    if (agenturID) {
      url += `&agenturId=${agenturID}`;
    }
    if (aTeamID) {
      url += `&aTeamId=${aTeamID}`;
    }

    console.log("getCustomerDetails URL:", url);
    const response = await fetch(url);

    // Text-Response abrufen
    const responseText = await response.text();

    let data;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      console.error("JSON-Parsing-Fehler:", parseError);
      return { success: false, error: "Server-Antwort konnte nicht verarbeitet werden" };
    }

    return data;
  } catch (err) {
    console.error('Fehler in getCustomerDetails:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Einverständnisserklärung als PDF herunterladen
export const downloadConsentForm = async (userId, customerId) => {
  try {
    const url = `${API_BASE_URL}?action=downloadConsentForm&userId=${userId}&customerId=${customerId}`;
    const response = await fetch(url);

    // Prüfen ob es ein PDF ist (Content-Type: application/pdf)
    const contentType = response.headers.get('content-type');

    if (contentType && contentType.includes('application/pdf')) {
      // PDF als Blob herunterladen
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;

      // Dateiname aus Content-Disposition Header extrahieren oder generieren
      const contentDisposition = response.headers.get('content-disposition');
      let filename = 'Einverstaendniserklaerung.pdf';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      return { success: true };
    } else {
      // Fehlerantwort als JSON parsen
      const errorData = await response.json();
      return { success: false, error: errorData.error || 'Fehler beim Download der PDF' };
    }
  } catch (err) {
    console.error('Fehler in downloadConsentForm:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Produkt zum Kunden hinzufügen
export const addProductToCustomer = async (userId, customerId, productType) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addProductToCustomer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, customerId, productType }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getPvLeadProperties = async (userId, customerId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getPvLeadProperties&userId=${userId}&customerId=${customerId}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateLeadStatus = async (userId, customerId, status, boComment) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateLeadStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        customerId,
        status,
        bo_kommentar: boComment
      }),
    });

    const data = await response.json();

    // Debug-Logging
    console.log('UpdateLeadStatus Response:', data);

    if (!data.success) {
      console.error('UpdateLeadStatus Error:', data.error);
    }

    return data;
  } catch (err) {
    console.error('UpdateLeadStatus Network Error:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getWpLeadProperties = async (userId, customerId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getWpLeadProperties&userId=${userId}&customerId=${customerId}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Wärmepumpenstatus aktualisieren
export const updateWpLeadStatus = async (userId, customerId, status) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateWpLeadStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, customerId, status }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const addComment = async (userId, customerId, comment) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addComment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, customerId, comment }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Anruf hinzufügen
export const addCall = async (userId, customerId, status, kommentar, ruckrufZeit = null) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addCall`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        customerId,
        status,
        kommentar,
        ruckrufZeit
      }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Lead hinzufügen
export const addLead = async (leadData) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addLead`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(leadData),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Teams abrufen
export const getTeams = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getTeams`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Aktualisierte createUser-Funktion
export const createUser = async (userData, adminId) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=createUser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...userData,
        adminId, // Der aktuelle Benutzer, der einen neuen Benutzer erstellt
        agenturId: userData.agenturId // NEU: Agentur-ID mitsenden, falls vorhanden
      }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Fehler in createUser:", err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getOrganizations = async (userId) => {
  try {
    // Prüfen, ob userId vorhanden ist
    if (!userId) {
      console.error("getOrganizations aufgerufen ohne userId");
      return { success: false, error: "Benutzer-ID fehlt" };
    }

    // API-Aufruf mit POST-Methode für Konsistenz
    const response = await fetch(`${API_BASE_URL}?action=getOrganizations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });

    // Antwort in JSON umwandeln
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Fehler in getOrganizations API:", err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getOrganizationsByUser = async (userId) => {
  try {
    // Prüfen, ob userId vorhanden ist
    if (!userId) {
      console.error("getOrganizationsByUser aufgerufen ohne userId");
      return { success: false, error: "Benutzer-ID fehlt" };
    }

    // API-Aufruf mit POST-Methode für Konsistenz
    const response = await fetch(`${API_BASE_URL}?action=getOrganizationsByUser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });

    // Antwort in JSON umwandeln
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Fehler in getOrganizationsByUser API:", err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getOrganization = async (userId, organizationId) => {
  try {

    // Methode auf POST umstellen und Parameter im Body senden
    const response = await fetch(`${API_BASE_URL}?action=getOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in getOrganization:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const createOrganization = async (userId, name, description = '') => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=createOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, name, description }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in createOrganization:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateOrganization = async (userId, organizationId, name, description = '') => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=updateOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId, name, description }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in updateOrganization:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteOrganization = async (userId, organizationId) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=deleteOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in deleteOrganization:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Team Management
export const getTeamsByOrganization = async (userId, organizationId) => {
  try {
    // Konsistente Konsolen-Ausgabe für bessere Fehleranalyse

    // Methode auf POST umstellen und Parameter im Body senden
    const response = await fetch(`${API_BASE_URL}?action=getTeamsByOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in getTeamsByOrganization:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};


export const getUsersByOrganization = async (userId, organizationId, options = {}) => {

  try {
    const {
      searchName = '',
      page = 1,
      perPage = 20,
      filters = {}
    } = options;

    // Die grundlegende POST-Methode beibehalten
    const response = await fetch(`${API_BASE_URL}?action=getUsersByOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        organizationId,
        searchName,
        page,
        perPage,
        filters
      }),
    });

    // Text-Response abrufen, um zu prüfen, ob es gültiges JSON ist
    const text = await response.text();

    let data;
    try {
      // Versuchen, den Text als JSON zu parsen
      data = JSON.parse(text);
    } catch (parseError) {
      const errorMatch = text.match(/<b>(.+?)<\/b>/);
      const errorMessage = errorMatch ? errorMatch[1] : "Unbekannter Server-Fehler";
      return {
        success: false,
        error: `Server-Fehler: ${errorMessage}`
      };
    }

    return data;
  } catch (err) {
    console.error('Fehler in getUsersByOrganization:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Neue API-Funktion speziell für Organization Members Management mit Pagination und serverseitiger Filterung
export const getOrganizationMembersPaginated = async (userId, organizationId, options = {}) => {
  try {
    const {
      searchName = '',
      page = 1,
      perPage = 25,
      filters = {}
    } = options;

    const response = await fetch(`${API_BASE_URL}?action=getOrganizationMembersPaginated`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        organizationId,
        searchName,
        page,
        perPage,
        filters
      }),
    });

    // Text-Response abrufen, um zu prüfen, ob es gültiges JSON ist
    const text = await response.text();

    let data;
    try {
      // Versuchen, den Text als JSON zu parsen
      data = JSON.parse(text);
    } catch (parseError) {
      const errorMatch = text.match(/<b>(.+?)<\/b>/);
      const errorMessage = errorMatch ? errorMatch[1] : "Unbekannter Server-Fehler";
      return {
        success: false,
        error: `Server-Fehler: ${errorMessage}`
      };
    }

    return data;
  } catch (err) {
    console.error('Fehler in getOrganizationMembersPaginated:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};
export const createTeam = async (userId, organizationId, name, description = '', isDefault = false) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=createTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: {
          userId,
          organizationId,
          name,
          description,
          isDefault
        }
      }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in createTeam:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const createProjekt = async (userId, organizationId, name, description = '', isDefault = false) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=createProjekt`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId, name, description, isDefault }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in createProjekt:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteTeam = async (userId, teamId) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=deleteTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, teamId }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in deleteTeam:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const setDefaultTeam = async (userId, organizationId, teamId) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=setDefaultTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId, teamId }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in setDefaultTeam:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const addUserToTeam = async (userId, targetUserId, teamId) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=addUserToTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, targetUserId, teamId }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in addUserToTeam:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const removeUserFromTeam = async (userId, targetUserId, teamId) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=removeUserFromTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, targetUserId, teamId }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in removeUserFromTeam:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateUserRole = async (userId, targetUserId, roleType) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=updateUserRole`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, targetUserId, roleType }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in updateUserRole:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Neue Funktion zum Aktualisieren von Benutzerdaten
export const updateUserData = async (userId, targetUserId, userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateUserData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        targetUserId,
        fullName: userData.fullName,
        email: userData.email,
        roleType: userData.roleType,
        agentur_id: userData.agentur_id,
        a_team_id: userData.a_team_id,
        newPassword: userData.newPassword || ''
      }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in updateUserData:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Funktion zum Deaktivieren/Aktivieren eines Benutzers
export const toggleUserStatus = async (userId, targetUserId, active) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=toggleUserStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        targetUserId,
        active
      }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in toggleUserStatus:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getUsersByRole = async (userId, roleType = null, organizationId = null) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=getUsersByRole`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        roleType,
        organizationId
      }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Fehler in getUsersByRole:", err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getRoleName = (roleType) => {
  switch (parseInt(roleType, 10)) {
    case 1: return 'Administrator';
    case 2: return 'Teamleiter';
    case 3: return 'Organisationsleiter';
    case 4: return 'Callcenter Leader';
    case 5: return 'Callcenter Mitarbeiter';
    case 6: return 'Fachberater';
    case 7: return 'Agentur Leiter';
    default: return 'Benutzer';
  }
};

export const hasPermission = (user, permission) => {
  if (!user) return false;

  const roleType = parseInt(user.role_type || 0, 10);

  switch (permission) {
    case 'createUser':
      return roleType === 1 || roleType === 3;  // Admin oder Organisationsleiter

    case 'manageOrganization':
      return roleType === 1 || roleType === 3;  // Admin oder Organisationsleiter

    case 'manageAllOrganizations':
      return roleType === 1;  // Nur Admin

    case 'manageTeams':
      return roleType === 1 || roleType === 3;  // Admin oder Organisationsleiter

    case 'manageTeamMembers':
      return roleType === 1 || roleType === 2 || roleType === 3;  // Admin, Teamleiter oder Organisationsleiter

    case 'viewOwnTermine':
      return roleType === 6;

    default:
      return false;
  }
};

export const changePassword = async (userId, currentPassword, newPassword) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=changePassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        currentPassword,
        newPassword
      }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in changePassword API:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteUser = async (adminId, targetUserId) => {
  try {

    const response = await fetch(`${API_BASE_URL}?action=deleteUser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: adminId, // Der aktuelle Benutzer, der die Löschung durchführt
        targetUserId  // Der zu löschende Benutzer
      }),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Fehler in deleteUser:", err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Funktion zum Abrufen aller Leads eines Teams
export const getTeamLeads = async (userId, teamId, startDate = null, endDate = null) => {
  try {
    const body = { userId, teamId };
    if (startDate && endDate) {
      body.startDate = startDate;
      body.endDate = endDate;
    }

    const response = await fetch(`${API_BASE_URL}?action=getTeamLeads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error('Fehler in getTeamLeads:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Funktion zum Abrufen aller Leads einer Organisation
export const getOrganizationLeads = async (userId, organizationId, limit, page) => {
  const body = { userId, organizationId };
  if (typeof limit !== 'undefined' && typeof page !== 'undefined') {
    body.limit = limit;
    body.page = page;
  }
  try {
    const response = await fetch(`${API_BASE_URL}?action=getOrganizationLeads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Fehler in getOrganizationLeads:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Funktion zum Abrufen aller Leads einer Organisation mit erweiterten Filtern
export const getOrganizationLeadsPaginated = async (userId, organizationId, limit, page, filters = {}) => {
  try {
    const body = {
      userId,
      organizationId,
      limit,
      page,
      ...filters
    };

    const response = await fetch(`${API_BASE_URL}?action=getOrganizationLeadsPaginated`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Fehler in getOrganizationLeadsPaginated:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getCallcenterLeadsPaginated = async (userId, organizationId, limit, page, filters = {}) => {
  try {
    const body = {
      userId,
      organizationId,
      limit,
      page,
      ...filters // Enthält z.B. search, status_pv, status_wp, etc.
    };
    const response = await fetch(`${API_BASE_URL}?action=getCallcenterLeadsPaginated`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Fehler in getCallcenterLeadsPaginated:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getStellungnahmen = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getStellungnahmen&userId=${userId}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Neue Stellungnahme hinzufügen
export const addStellungnahme = async (stellungnahmeData) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addStellungnahme`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(stellungnahmeData),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Kunden für Dropdown abrufen
export const getCustomersForDropdown = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getCustomersForDropdown&userId=${userId}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Stellungnahme-Status aktualisieren
export const updateStellungnahmeStatus = async (userId, stellungnahmeId, status) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateStellungnahmeStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, stellungnahmeId, status }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Stellungnahme mit Antwort aktualisieren
export const updateStellungnahmeWithAnswer = async (userId, stellungnahmeId, status, antwort) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateStellungnahmeWithAnswer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, stellungnahmeId, status, antwort }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getStellungnahmenByCustomer = async (userId, customerId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getStellungnahmenByCustomer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, customerId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getTermine = async (userId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      userId: userId.toString(),
      ...filters
    });

    const response = await fetch(`${API_BASE_URL}?action=getTermine&${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('getTermine error:', error);
    throw error;
  }
};

// Neue Funktion für wochenbasierte Termin-Abfrage (Performance-Optimierung)
export const getTermineByWeek = async (userId, weekStart, filters = {}) => {
  try {
    const params = new URLSearchParams({
      userId: userId.toString(),
      weekStart: weekStart,
      ...filters
    });

    const response = await fetch(`${API_BASE_URL}?action=getTermineByWeek&${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('getTermineByWeek error:', error);
    throw error;
  }
};

// Neuen Termin hinzufügen
export const addTermin = async (userId, terminData) => {
  console.log("terminData : ", terminData)
  try {
    const response = await fetch(`${API_BASE_URL}?action=addTermin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        ...terminData
      }),
    });

    const responseData = await response.json();

    if (!response.ok) {
      const errorMessage = responseData.error || `HTTP error! status: ${response.status}`;
      throw new Error(errorMessage);
    }

    return responseData;
  } catch (error) {
    console.error('addTermin error:', error);
    throw error;
  }
};

// Termin löschen
export const deleteTermin = async (userId, terminId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteTermin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        terminId
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('deleteTermin error:', error);
    throw error;
  }
};

// Kundenstatus aktualisieren
export const updateCustomerStatus = async (userId, customerId, status) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateCustomerStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, customerId, status }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Kunden nach Status filtern (für Callcenter)
export const getCustomersByStatus = async (userId, status) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getCustomersByStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, status }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Kunden in Customer-Tabelle anlegen
export const addCustomer = async (customerData) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addCustomer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerData),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getFachberaterTermine = async (userId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      userId: userId.toString(),
      ...filters
    });

    const response = await fetch(`${API_BASE_URL}?action=getFachberaterTermine&${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('getFachberaterTermine error:', error);
    throw error;
  }
};

// Termin-Details
export const getTerminDetails = async (userId, terminId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getTerminDetails`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        terminId
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('getTerminDetails error:', error);
    throw error;
  }
};

export const sendSmsVerification = async (userId, phoneNumber) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=sendSmsVerification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, phoneNumber }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const verifySmsCode = async (userId, verificationCode) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=verifySmsCode`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, verificationCode }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getTermineByCustomer = async (userId, customerId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getTermineByCustomer&userId=${userId}&customerId=${customerId}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteTerminAndUpdateCustomer = async (userId, terminId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteTerminAndUpdateCustomer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, terminId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const addBoComment = async (userId, customerId, comment) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addBoComment`, { // Aktion angepasst
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, customerId, comment }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Termin stornieren
export const cancelTermin = async (userId, terminId, stornierungsgrund) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=cancelTermin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        terminId,
        stornierungsgrund
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('cancelTermin error:', error);
    throw error;
  }
};

export const updateLeadProperties = async (userId, customerId, productType, properties) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateLeadProperties`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        customerId,
        leadType: productType,
        properties
      })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Webhook für Lead-Status-Änderung triggern
export const triggerLeadStatusWebhook = async (userId, customerId, status, leadType) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=triggerLeadStatusWebhook`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        customerId,
        status,
        leadType
      })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Termin aktualisieren
export const updateTermin = async (userId, terminId, updateData) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateTermin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        terminId,
        ...updateData
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('updateTermin error:', error);
    throw error;
  }
};

export const updateCustomerData = async (userId, customerId, customerData) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=update_customer_data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
        customer_id: customerId,
        customer_data: customerData
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fehler beim Aktualisieren der Kundendaten:', error);
    return { success: false, error: 'Netzwerkfehler beim Aktualisieren der Kundendaten' };
  }
};

export const getCallsByOrganization = async (userId, organizationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getCallsByOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Status-Änderungs-Historie abrufen
export const getStatusChangeHistory = async (userId, leadId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getStatusChangeHistory`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'getStatusChangeHistory',
        userId: userId,
        leadId: leadId
      }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fehler beim Abrufen der Status-Historie:', error);
    return { success: false, error: 'Netzwerkfehler' };
  }
};

// Status-Statistiken für Callcenter-Mitarbeiter abrufen
export const getStatusStatistics = async (userId, organizationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getStatusStatistics`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'getStatusStatistics',
        userId: userId,
        organizationId: organizationId
      }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fehler beim Abrufen der Status-Statistiken:', error);
    return { success: false, error: 'Netzwerkfehler' };
  }
};

// Status-Änderungen für jeden Mitarbeiter abrufen
export const getEmployeeStatusChanges = async (userId, organizationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getEmployeeStatusChanges`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'getEmployeeStatusChanges',
        userId: userId,
        organizationId: organizationId
      }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fehler beim Abrufen der Mitarbeiter-Status-Änderungen:', error);
    return { success: false, error: 'Netzwerkfehler' };
  }
};

// Organisation-ID eines Leads ermitteln
export const getLeadOrganizationId = async (userId, leadId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getLeadOrganizationId`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: userId,
        leadId: leadId
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('getLeadOrganizationId error:', error);
    throw error;
  }
};

export const getAllFachberater = async (userId, team_id) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getAllFachberater&userId=${userId}${team_id ? `&team_id=${team_id}` : ''}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Neue Funktion für Datenübertragung aller Termine einer Organisation
export const transferOrganizationData = async (userId, organizationId, targetDate) => {
  try {
    const body = { userId, organizationId };
    if (targetDate) body.targetDate = targetDate;
    const response = await fetch(`${API_BASE_URL}?action=transferOrganizationData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    // Prüfen ob Response CSV ist (Content-Type: text/csv)
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('text/csv')) {
      // JSON-Response aus Header extrahieren
      const jsonResponseHeader = response.headers.get('x-json-response');
      let jsonData = null;
      if (jsonResponseHeader) {
        try {
          jsonData = JSON.parse(atob(jsonResponseHeader));
        } catch (e) {
          console.error('Fehler beim Parsen der JSON-Response aus Header:', e);
        }
      }

      // CSV-Datei herunterladen
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      // Dateinamen aus Content-Disposition Header extrahieren
      const contentDisposition = response.headers.get('content-disposition');
      let filename = 'BEN_Daten.csv';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      // JSON-Daten zurückgeben für Console-Output
      return jsonData || { success: true, message: 'CSV-Datei wurde heruntergeladen' };
    }

    // Falls JSON zurückkommt (Fehlerfall)
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Neue Funktion für Datenübertragung der Organisation 6 (Energie+)
export const transferEnergiePlusData = async (userId, organizationId, targetDate) => {
  try {
    const body = { userId, organizationId };
    if (targetDate) body.targetDate = targetDate;
    const response = await fetch(`${API_BASE_URL}?action=transferEnergiePlusData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    // Prüfen ob Response CSV ist (Content-Type: text/csv)
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('text/csv')) {
      // JSON-Response aus Header extrahieren
      const jsonResponseHeader = response.headers.get('x-json-response');
      let jsonData = null;
      if (jsonResponseHeader) {
        try {
          jsonData = JSON.parse(atob(jsonResponseHeader));
        } catch (e) {
          console.error('Fehler beim Parsen der JSON-Response aus Header:', e);
        }
      }

      // CSV-Datei herunterladen
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      // Dateinamen aus Content-Disposition Header extrahieren
      const contentDisposition = response.headers.get('content-disposition');
      let filename = 'EnergiePlus_Daten.csv';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      // JSON-Daten zurückgeben für Console-Output
      return jsonData || { success: true, message: 'CSV-Datei wurde heruntergeladen' };
    }

    // Falls JSON zurückkommt (Fehlerfall)
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Funktion zum Exportieren der Organisation Leads für Organisationsleiter
export const exportOrganizationLeads = async (userId) => {
  try {
    const body = { userId };
    const response = await fetch(`${API_BASE_URL}?action=exportOrganizationLeads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    // Prüfen ob Response CSV ist (Content-Type: text/csv)
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('text/csv')) {
      // JSON-Response aus Header extrahieren
      const jsonResponseHeader = response.headers.get('x-json-response');
      let jsonData = null;
      if (jsonResponseHeader) {
        try {
          jsonData = JSON.parse(atob(jsonResponseHeader));
        } catch (e) {
          console.error('Fehler beim Parsen der JSON-Response aus Header:', e);
        }
      }

      // CSV-Datei herunterladen
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      // Dateinamen aus Content-Disposition Header extrahieren
      const contentDisposition = response.headers.get('content-disposition');
      let filename = 'Organisation_Leads.csv';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      // JSON-Daten zurückgeben für Console-Output
      return jsonData || { success: true, message: 'CSV-Datei wurde heruntergeladen' };
    }

    // Falls JSON zurückkommt (Fehlerfall)
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Termin-Liste abrufen
export const getTermineListe = async (userId, organizationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getTermineListe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
        organization_id: organizationId
      }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Termin-Liste mit Paginierung abrufen
export const getTermineListePaginated = async (userId, organizationId, limit, page, filters = {}) => {
  try {
    const body = {
      user_id: userId,
      organization_id: organizationId,
      limit,
      page,
      ...filters // Enthält z.B. search, sortBy, sortOrder, etc.
    };
    const response = await fetch(`${API_BASE_URL}?action=getTermineListePaginated`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Fehler in getTermineListePaginated:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Alle verfügbaren Fachberater für Termine abrufen
export const getAllFachberaterForTermine = async (userId, organizationId) => {
  try {
    const body = {
      user_id: userId,
      organization_id: organizationId
    };
    const response = await fetch(`${API_BASE_URL}?action=getAllFachberaterForTermine`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Fehler in getAllFachberaterForTermine:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// E-Mail senden
export const sendEmail = async (emailData) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=sendEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(emailData),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Opt-In Token validieren
export const validateOptInToken = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=validateOptInToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Opt-In bestätigen
export const confirmOptIn = async (token, postleitzahl, datenschutzAccepted) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=confirmOptIn`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        postleitzahl,
        datenschutzAccepted
      }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Lead-Vorlagen-API
export const getLeadTemplates = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getLeadTemplates`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const saveLeadTemplate = async (userId, name, type, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=saveLeadTemplate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, name, type, data })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteLeadTemplate = async (userId, templateId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteLeadTemplate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, templateId })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Sub-Team API Funktionen
export const getSubTeams = async (userId, organizationId, teamId = null) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getSubTeams`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId, teamId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getSubTeamsByTeam = async (userId, teamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getSubTeamsByTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, teamId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const createSubTeam = async (userId, organizationId, teamId, name, description = '') => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=createSubTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId, teamId, name, description }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateSubTeam = async (userId, subTeamId, name, description = '') => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateSubTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, subTeamId, name, description }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteSubTeam = async (userId, subTeamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteSubTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, subTeamId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const addUserToSubTeam = async (userId, targetUserId, subTeamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addUserToSubTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, targetUserId, subTeamId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const removeUserFromSubTeam = async (userId, targetUserId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=removeUserFromSubTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, targetUserId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Sub-Team-Informationen eines Benutzers laden
export const getUserSubTeamInfo = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getUserSubTeamInfo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Sub-Team-Leads abrufen
export const getSubTeamLeads = async (userId, subTeamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getSubTeamLeads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, subTeamId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const assignUserToSubTeam = async (userId, subTeamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=assignUserToSubTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, subTeamId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Prüft, ob der aktuelle Benutzer ausgeloggt werden muss (ResetTeam=1)
export const checkResetTeam = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=checkResetTeam&userId=${userId}`);
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Setzt ResetTeam für den Benutzer auf 1
export const setResetTeam = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=setResetTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });

    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Abrechnung erstellen
export const createBillingReport = async (userId, teamId, dateFrom, dateTo, format = 'csv', applySonderregelung = true, agenturId = null) => {
  try {
    const requestData = {
      userId,
      teamId,
      dateFrom,
      dateTo,
      format,
      applySonderregelung,
      agenturId
    };

    // Debug-Log für gesendete Daten
    console.log('createBillingReport - Sende Daten:', requestData);

    const response = await fetch(`${API_BASE_URL}?action=createBillingReport`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    console.log('createBillingReport - Antwort:', result);

    return result;
  } catch (err) {
    console.error('createBillingReport - Fehler:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// XLSX-Datei erstellen (Frontend)
export const createXlsxReport = async (data, fileName, dataSpecial = null) => {
  try {
    // Dynamischer Import der xlsx Bibliothek
    const XLSX = await import('xlsx');

    // Arbeitsmappe erstellen
    const workbook = XLSX.utils.book_new();

    // Funktion zum Erstellen eines Arbeitsblatts
    const createWorksheet = (data, sheetName) => {
      const worksheetData = [];

      // Header-Zeile mit erweiterten Spalten
      worksheetData.push([
        'Produkt',
        'Agentur',
        'Lead-Datum',
        'Projekt',
        'Kundenname',
        'Aussendienstler',
        'Qualifiziert am',
        'Qualifiziert',
        'Stand',
        'Termin-Datum',
        'Mitarbeiter'
      ]);

      // Daten-Zeilen
      data.forEach(item => {
        worksheetData.push([
          item.produkt,
          item.agentur,
          item.lead_datum,
          item.projekt,
          item.kundenname,
          item.aussendienstler,
          item.qualifiziert_am,
          item.qualifiziert,
          item.stand,
          item.termin_datum,
          item.user_name || ''
        ]);
      });

      return XLSX.utils.aoa_to_sheet(worksheetData);
    };

    // Hauptarbeitsblatt (normale Leads)
    if (data && data.length > 0) {
      const mainWorksheet = createWorksheet(data, 'Normale Abrechnung');
      XLSX.utils.book_append_sheet(workbook, mainWorksheet, 'Normale Abrechnung');
    }

    // Sonderbehandlung Arbeitsblatt (falls vorhanden)
    if (dataSpecial && dataSpecial.length > 0) {
      const specialWorksheet = createWorksheet(dataSpecial, 'Sonderbehandlung');
      XLSX.utils.book_append_sheet(workbook, specialWorksheet, 'Sonderbehandlung');
    }

    // XLSX-Datei generieren und herunterladen
    XLSX.writeFile(workbook, fileName);

    return { success: true };
  } catch (err) {
    console.error('createXlsxReport - Fehler:', err);
    return { success: false, error: `Fehler beim Erstellen der XLSX-Datei: ${err.message}` };
  }
};

// Agentur-Leads nach Postleitzahl abrufen (Agenturleiter-Übersicht)
export const getAgenturLeadsByPlz = async (userId, plz) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getAgenturLeadsByPlz`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, plz }),
    });
    return await response.json();
  } catch (err) {
    console.error('getAgenturLeadsByPlz - Fehler:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Agentur-Leads nach PLZ als Excel herunterladen (holt Daten + baut XLSX im Frontend)
export const downloadAgenturLeadsByPlzExcel = async (userId, plz) => {
  try {
    const result = await getAgenturLeadsByPlz(userId, plz);
    if (!result.success) {
      return result;
    }

    const leads = Array.isArray(result.leads) ? result.leads : [];

    const XLSX = await import('xlsx');
    const workbook = XLSX.utils.book_new();

    const worksheetData = [[
      'Name',
      'Nachname',
      'Straße',
      'Hausnummer',
      'PLZ',
      'Stadt',
      'E-Mail',
      'Handy',
      'Produkt',
      'Projekt',
      'Status PV',
      'Status WP',
      'Opt-In',
      'Erstellt',
    ]];

    leads.forEach(l => {
      worksheetData.push([
        l.name || '',
        l.nachname || '',
        l.strasse || '',
        l.hausnummer || '',
        l.postleitzahl || '',
        l.stadt || '',
        l.email || '',
        l.handy || '',
        l.produkt || '',
        l.projekt || '',
        l.status_pv || '',
        l.status_wp || '',
        (String(l.opt_in) === '1' ? 'Ja' : 'Nein'),
        l.erstellt || '',
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, `PLZ ${plz}`.substring(0, 31));

    const fileName = `Leads_PLZ_${plz}.xlsx`;
    XLSX.writeFile(workbook, fileName);

    return { success: true, count: leads.length };
  } catch (err) {
    console.error('downloadAgenturLeadsByPlzExcel - Fehler:', err);
    return { success: false, error: `Fehler beim Excel-Export: ${err.message}` };
  }
};

// Teams einer Organisation für Abrechnung abrufen
export const getTeamsForBilling = async (userId, organizationId) => {
  try {
    console.log('getTeamsForBilling - Sende Anfrage:', { userId, organizationId });

    // Parameter als POST-Body senden statt GET-Parameter
    const response = await fetch(`${API_BASE_URL}?action=getTeamsByOrganization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        organizationId
      }),
    });
    const result = await response.json();

    console.log('getTeamsForBilling - Antwort erhalten:', result);

    return result;
  } catch (err) {
    console.error('getTeamsForBilling - Fehler:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Projekt exportieren - alle Daten zu einem Projekt als CSV
export const exportProjectData = async (userId, teamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=exportProjectData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, teamId }),
    });

    const result = await response.json();
    return result;
  } catch (err) {
    console.error('exportProjectData - Fehler:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Kunden-CSV im Transfer-Format; pro Zeile ein ausgewählter Termin (csvData base64, fileName .csv)
export const exportCustomerTerminTransferCsv = async (
  userId,
  customerId,
  terminIds,
  agenturId,
  aTeamId
) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=exportCustomerTerminTransferCsv`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'exportCustomerTerminTransferCsv',
        userId,
        customerId,
        terminIds,
        agenturId: agenturId ?? null,
        aTeamId: aTeamId ?? null,
      }),
    });

    const result = await response.json();
    return result;
  } catch (err) {
    console.error('exportCustomerTerminTransferCsv - Fehler:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Projekt und alle Daten löschen
export const deleteProjectAndData = async (userId, teamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteProjectAndData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, teamId }),
    });

    const result = await response.json();
    return result;
  } catch (err) {
    console.error('deleteProjectAndData - Fehler:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Teamleiter für einen Benutzer abfragen
export const getSubTeamleiter = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getSubTeamleiter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user_id: userId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Teamleiter für einen Benutzer setzen (erweitert um team_id)
export const setSubTeamleiter = async (userId, teamleiterId, organisationId, teamId = 0) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=setSubTeamleiter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user_id: userId, teamleiter_id: teamleiterId, organisation_id: organisationId, team_id: teamId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Alle Mitglieder eines Teamleiters abrufen
export const getMyTeamMembers = async (teamleiterId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getMyTeamMembers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ teamleiter_id: teamleiterId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Alle Leads der Mitglieder eines Teamleiters abrufen
export const getLeadsOfMyTeam = async (teamleiterId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getLeadsOfMyTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ teamleiter_id: teamleiterId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Prüfen ob ein Benutzer als Teamleiter in sub_teamleiter steht
export const checkIsSubTeamleiter = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=checkIsSubTeamleiter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user_id: userId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const createAgentur = async (name, beschreibung, organization_id) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=createAgentur`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, beschreibung, organization_id })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getAgenturenByOrganization = async (organization_id) => {
  try {
    console.log("organization_id : ", organization_id)
    const response = await fetch(`${API_BASE_URL}?action=getAgenturenByOrganization`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ organization_id })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getUsersFromOrganizationForAgenturen = async (organisation_id) => {
  console.log("Das haben wir übergeben : ", organisation_id)
  try {
    const response = await fetch(`${API_BASE_URL}?action=getUsersFromOrganizationForAgenturen`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ organisation_id })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Funktion zum Abrufen der Leads einer Agentur (Pagination + optionale Filter im Body)
export const getAgenturLeads = async (userId, agenturId, a_team_id = null, options = {}) => {
  try {
    const body = {
      userId,
      agenturId,
      a_team_id: a_team_id != null && a_team_id !== '' ? a_team_id : null,
      page: options.page ?? 1,
      perPage: options.perPage ?? 50,
      startDate: options.startDate ?? null,
      endDate: options.endDate ?? null,
      search: options.search != null && String(options.search).trim() !== '' ? String(options.search).trim() : null,
      statusPv: options.statusPv || null,
      statusWp: options.statusWp || null,
      projekt: options.projekt || null,
      dienstleister: options.dienstleister || null,
      teamName: options.teamName || null,
      sortBy: options.sortBy || 'erstellt',
      sortOrder: options.sortOrder || 'desc',
      sortByQualiDatum: options.sortByQualiDatum ? true : false,
      includeFilterMeta: options.includeFilterMeta ? true : false,
      forDashboard: options.forDashboard ? true : false,
      forStats: options.forStats ? true : false,
    };
    const response = await fetch(`${API_BASE_URL}?action=getAgenturLeads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  } catch (err) {
    console.error('Fehler in getAgenturLeads:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

/** Kompakte Kennzahlen fürs Agentur-/Agentur-Team-Dashboard (ohne vollständige Lead-Listen). */
export const getAgenturLeadStats = async (userId, agenturId, a_team_id = null, options = {}) => {
  try {
    const body = {
      userId,
      agenturId,
      a_team_id: a_team_id != null && a_team_id !== '' ? a_team_id : null,
      startDate: options.startDate ?? null,
      endDate: options.endDate ?? null,
      search: options.search != null && String(options.search).trim() !== '' ? String(options.search).trim() : null,
      statusPv: options.statusPv || null,
      statusWp: options.statusWp || null,
      projekt: options.projekt || null,
      dienstleister: options.dienstleister || null,
      teamName: options.teamName || null,
    };
    const response = await fetch(`${API_BASE_URL}?action=getAgenturLeadStats`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    return await response.json();
  } catch (err) {
    console.error('Fehler in getAgenturLeadStats:', err);
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getTeamsByAgentur = async (userId, agenturId, onlyActive = false) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getTeamsByAgentur`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, agenturId, onlyActive }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const createAgenturTeam = async (userId, agenturId, name, beschreibung = '') => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=createAgenturTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, agenturId, name, beschreibung }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateTeam = async (userId, teamId, name, beschreibung = '', active = true) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, teamId, name, beschreibung, active }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export async function deleteATeam(userId, teamId) {
  const response = await fetch(`${API_BASE_URL}?action=deleteATeam`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userId, teamId }),
  });
  return response.json();
}

export const getUsersByAgentur = async (userId, agenturId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getUsersByAgentur`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, agenturId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getUsersByTeam = async (userId, teamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getUsersByTeam`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, teamId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// Funktion zum Laden aller Team-Mitglieder (auch ohne Leads)
export const getTeamMembers = async (userId, teamId, agenturId = null, includeInactive = false) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getTeamMembers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, teamId, agenturId, includeInactive }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getAgenturById = async (userId, agenturId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getAgenturById`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, agenturId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteAgentur = async (userId, agenturId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteAgentur`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, agenturId })
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getMyBewertungen = async (userId, isFachberater) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getMyBewertungen`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, isFachberater }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getBewertung = async (userId, leadId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getBewertung`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, leadId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const UpdateAgentur = async (userId, agenturId, name, beschreibung, active) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=UpdateAgentur`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, agenturId, name, beschreibung, active }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

/** Agentur inkl. Leadpreise (PV, WP, PV+WP) aktualisieren */
export const updateAgenturData = async (userId, agenturId, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateAgenturData`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, agenturId, ...data }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

/** Organisations-Teams (Projekte), auf die eine Agentur laut Freigabeliste zugreifen darf */
export const getAgenturAllowedTeams = async (userId, agenturId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getAgenturAllowedTeams`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, agenturId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// ===========================
// PASSWORD RESET API FUNKTIONEN
// ===========================

/**
 * Passwort-Reset anfordern
 * Sendet eine E-Mail mit einem Reset-Link an den Benutzer
 */
export const requestPasswordReset = async (email) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=RequestPasswordReset`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

/**
 * Reset-Token validieren
 * Prüft ob der Token gültig, nicht verwendet und nicht abgelaufen ist
 */
export const validateResetToken = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=validateResetToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

/**
 * Passwort mit Token zurücksetzen
 * Setzt ein neues Passwort für den Benutzer
 */
export const resetPassword = async (token, newPassword) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=resetPassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token, newPassword }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

/**
 * Fügt eine Dummy-E-Mail für einen Kunden hinzu
 * Format: vorname.nachname@keinemail.de
 */
export const addDummyEmail = async (userId, customerId, vorname, nachname) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addDummyEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        customerId,
        vorname,
        nachname
      }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// ==================== LAGERVERWALTUNG API ====================

export const getWarehouseItems = async (userId, organizationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getWarehouseItems`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const createWarehouseItem = async (userId, organizationId, name, description = '') => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=createWarehouseItem`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, organizationId, name, description }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateWarehouseItem = async (userId, itemId, name, description = '') => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateWarehouseItem`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, itemId, name, description }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteWarehouseItem = async (userId, itemId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteWarehouseItem`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, itemId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getWarehouseItemVariants = async (itemId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getWarehouseItemVariants`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ itemId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const addWarehouseItemVariant = async (userId, itemId, variantName, variantType = 'size', stockQuantity = 0, availableStock = null) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=addWarehouseItemVariant`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, itemId, variantName, variantType, stockQuantity, availableStock }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateWarehouseItemVariant = async (userId, variantId, variantName, variantType = 'size', stockQuantity = 0, availableStock = null) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateWarehouseItemVariant`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, variantId, variantName, variantType, stockQuantity, availableStock }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const deleteWarehouseItemVariant = async (userId, variantId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=deleteWarehouseItemVariant`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, variantId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// ==================== BESTELLUNGEN API ====================

export const getOrders = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getOrders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const createOrder = async (userId, items, notes = '', address = '') => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=createOrder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, items, notes, address }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const updateOrder = async (userId, orderId, updates) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=updateOrder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, orderId, ...updates }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getOrderDetails = async (userId, orderId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getOrderDetails`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, orderId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

// ==================== BENACHRICHTIGUNGEN API ====================

export const getNotifications = async (userId, limit = 5) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getNotifications`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, limit }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const markNotificationAsRead = async (userId, notificationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=markNotificationAsRead`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, notificationId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const markAllNotificationsAsRead = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=markAllNotificationsAsRead`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};

export const getUnreadNotificationCount = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?action=getUnreadNotificationCount`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });
    return await response.json();
  } catch (err) {
    return { success: false, error: `Netzwerkfehler: ${err.message}` };
  }
};